import { ONBOARDING_STAGES } from '../types/crm';

/**
 * The last onboarding stage, « Stable » (migration 20261004115328): the onboarding is over and
 * the client has left the board. Reached on the stage-7 criteria, hidden from the boards by default.
 */
export const STABLE_ONBOARDING_STAGE = 8;

/** The stages a client goes through on the board, « Stable » excluded. */
export const ACTIVE_ONBOARDING_STAGES = STABLE_ONBOARDING_STAGE - 1;

/** A board column's order_index is 8 + its stage (store/crm/helpers.ts). */
export function isStableBoardColumn(orderIndex: number): boolean {
  return orderIndex === 8 + STABLE_ONBOARDING_STAGE;
}

/** « 3/7 », or « Stable » once the onboarding is over. */
export function onboardingStageFraction(stage: number): string {
  return stage >= STABLE_ONBOARDING_STAGE ? 'Stable' : `${stage}/${ACTIVE_ONBOARDING_STAGES}`;
}

/** « Étape 3/7 », or « Stable » once the onboarding is over. */
export function onboardingStageLabel(stage: number): string {
  return stage >= STABLE_ONBOARDING_STAGE ? 'Stable' : `Étape ${onboardingStageFraction(stage)}`;
}

/** The stage's name, as onboarding_stage_name (SQL) gives it; '' for an unknown stage. */
export function onboardingStageName(stage: number): string {
  return ONBOARDING_STAGES.find((s) => s.number === stage)?.name ?? '';
}
